export const SITE_NAME = 'Rem Urban Clothes';
export const SITE_URL = 'https://www.remurban.uy';
export const WHATSAPP_NUMBER = '59899422152';
export const WHATSAPP_MESSAGE = 'Hola, estoy viendo la web de Rem Urban y quería consultar por...';

export const DEFAULT_SEO_DESCRIPTION =
  'Fabricantes de indumentaria urbana y deportiva en Ciudad de la Costa, Uruguay. Ropa para mujer, hombre y niños. Venta minorista y mayorista con envíos a todo el país.';

export const CATEGORY_LANDINGS = {
  mujer: {
    path: '/mujer',
    categoryName: 'Mujer',
    title: 'Ropa para Mujer en Uruguay',
    h1: 'Ropa para mujer',
    description: 'Indumentaria urbana y deportiva para mujer de Rem Urban Clothes. Conocé la colección y comprá online con envíos a todo Uruguay.',
    intro: 'Explorá nuestra colección de indumentaria urbana y deportiva para mujer, con opciones para distintos estilos y ocasiones.'
  },
  hombre: {
    path: '/hombre',
    categoryName: 'Hombre',
    title: 'Ropa para Hombre en Uruguay',
    h1: 'Ropa para hombre',
    description: 'Indumentaria urbana y deportiva para hombre de Rem Urban Clothes. Conocé la colección y comprá online con envíos a todo Uruguay.',
    intro: 'Explorá nuestra colección de indumentaria urbana y deportiva para hombre, con opciones para distintos estilos y ocasiones.'
  },
  ninos: {
    path: '/ninos',
    categoryName: 'Niños',
    title: 'Ropa para niños en Uruguay',
    h1: 'Ropa para niños',
    description: 'Indumentaria urbana y deportiva para niños de Rem Urban Clothes. Conocé la colección y comprá online con envíos a todo Uruguay.',
    intro: 'Explorá nuestra colección de indumentaria urbana y deportiva para niños, pensada para acompañarlos todos los días.'
  },
  'ropa-deportiva': {
    path: '/ropa-deportiva',
    subcategoryName: 'Deportivo',
    title: 'Ropa deportiva en Uruguay',
    h1: 'Ropa deportiva',
    description: 'Ropa deportiva de Rem Urban Clothes para mujer, hombre y niños. Comprá online con envíos a todo Uruguay.',
    intro: 'Encontrá prendas deportivas de Rem Urban Clothes disponibles para mujer, hombre y niños.'
  }
};

export const FAQ_ITEMS = [
  {
    question: '¿La ropa de Rem Urban es de fabricación propia?',
    answer: 'Sí. Rem Urban Clothes fabrica indumentaria urbana y deportiva para mujer, hombre y niños.'
  },
  {
    question: '¿Dónde está ubicada Rem Urban?',
    answer: 'Rem Urban Clothes trabaja desde Ciudad de la Costa, Canelones, Uruguay.'
  },
  {
    question: '¿Hacen envíos a todo Uruguay?',
    answer: 'Sí, realizamos envíos a todo Uruguay.'
  },
  {
    question: '¿Venden ropa por mayor?',
    answer: 'Sí. Podés contactarnos para consultar por compras mayoristas y recibir información sobre las líneas disponibles.'
  },
  {
    question: '¿Cómo puedo contactarme por WhatsApp?',
    answer: 'Podés escribirnos por WhatsApp desde el botón disponible en el sitio.'
  }
];
